<template>
  <b-card
    title="مدیریت محتواها"
  >
    <b-row align-h="center">
      <b-col
        lg="10"
        md="12"
      >
        <b-row
          align-h="end"
          style="min-height: 72px"
        >
          <b-col
            md="auto"
            class="mr-auto"
          >
            <b-button
              class="mt-md-2 mb-1 mb-md-0"
              variant="primary"
              :to="{ name: 'addcontent'}"
            >
              جدید
            </b-button>
          </b-col>
          <b-col md="auto">
            <b-form-group
              label="عنوان"
              label-for="Title"
              class="mt-1 mt-md-0"
            >
              <b-form-input
                v-model="filterOptions.Title"
                @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              class="mt-md-2 mb-1 mb-md-0"
              variant="warning"
              @click="update(1)"
            >فیلتر
            </b-button>
          </b-col>
        </b-row>
        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatecontent', params: { id: data.item.Type }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Type)="data">
            {{ enums('ContentType', 'value', data.value, 'text') }}
          </template>

          <template #cell(ContentDetails)="data">
            <span
              v-for="(item, index) in data.value"
              :key="index"
            >
              <b-badge
                style="line-height: unset; margin: 2px;"
                variant="light-secondary"
              >
                {{ item.Title }}
              </b-badge>
            </span>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updatecontent', params: { id: data.item.Type }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'Content',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Type',
          label: 'نوع',
        },
        {
          key: 'ContentDetails',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.content.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow || 0
          this.items = res.data || []
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
